export default __webpack_public_path__ + "static/media/45.2766b2f8.png";